import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegisteredUsersComponent } from './registered-users.component';
import { RegisteredUsersSearchComponent } from './registered-users-search/registered-users-search.component';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {MaterialModule} from '../../material.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {SearchModule} from '../../components/search/search.module';
import {LayoutModule} from '../../components/layout/layout.module';
import {FormsModule} from '@angular/forms';
import {DialogModule} from '../../components/dialog/dialog.module';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [RegisteredUsersComponent, RegisteredUsersSearchComponent],
    imports: [
        CommonModule,
        ArmTableModule,
        MaterialModule,
        ActionBarModule,
        SearchModule,
        LayoutModule,
        FormsModule,
        DialogModule,
        InfraModule
    ]
})
export class RegisteredUsersModule { }
